(ns frontend.page-components.zap-toolbar
  (:require
   [basic-components.dropdown-button :as dropdown-button]
   [clojure.string :as string]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.actions.account :as account-actions]
   [frontend.actions.entity :as entity-actions]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.utils :as fu]
   [frontend.view.modals.delete-confirmation.view :as delete-confirmation]
   [frontend.view.modals.error-message.view :as error-message-modal]
   [frontend.view.modals.events :as modals]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [ui.components.toggle.view :as toggle]
   [ui.dom-globals :as dg]
   [ui.data.app-core.sub :as app-core-sub]
   [ui.util :as uu]))

(defn label
  [text]
  [:span
   text])

(defn back-button
  [cb]
  [button/secondary-open
   {:class    "empty"
    :on-click (fn [_e]
                (when cb (cb))
                (dg/history-back))}
   [:span
    {:class "flex gap-2"}
    [:i.fal.fa-angle-left.text-2xl]
    (loc/tr :back)]])

(defn dropdown-button
  [custom-config]
  (merge {:toolbar-button?  false
          :dropdown-action? true
          :primary-button?  false
          :icon             :fa-question}
         custom-config))

(defn dropdown-toggle-item
  [custom-config]
  (merge {:toolbar-button?  false
          :dropdown-action? true
          :primary-button?  false
          :toggle-item?     true
          :icon             :fa-question}
         custom-config))

(defn new-entity-viewer-2024-toggle-and-divider
  []
  (let [new-company-viewer-preview-2024? @(rf/subscribe [::app-core-sub/new-company-viewer-preview-2024?])]
    (when new-company-viewer-preview-2024?
      [(dropdown-toggle-item
        {:id           :nev-2024-toggle
         :icon         :fa-eye
         :ord          -2
         :label        (loc/tr :classic-mode)
         :custom-item? true
         :value        [:div
                        {:class "flex justify-between gap-2 text-sm"}
                        [:div
                         {:class "flex items-center gap-2"}
                         [:i {:class "fal fa-eye"}]
                         [:span (loc/tr :classic-mode)]]
                        [toggle/toggle
                         {:checked? true}]]
         :on-select    #(account-actions/update-preferences
                         {:classic-entity-viewer-enabled? false})})
       {:ord              -1
        :divider?         true
        :dropdown-action? true}])))

(defn show-error-message!
  [{:keys [error message] :as _err}]
  ;; display error-message only for map-profile error to
  ;; keep functionality unchanged for other cases:
  ;; TODO consider showing this for all errors => must ensure exceptions
  ;;      relayed to frontend won't leak anything
  (let [show-error-message? (and (= error :bad-request)
                                 (string? message)
                                 (string/includes? message "map-profile"))]
    (modals/open-modal!
     error-message-modal/modal-key
     {:title          (loc/tr :attention)
      :body-content   [:span (loc/tr :failed-to-delete-entity)
                       (when show-error-message?
                         [:<>
                          [:br] [:br]
                          [:span "(" message ")"]])]
      :ok-button-text (loc/tr :ok)})))

(defn delete-allowed?
  [is-read-only-user? is-admin?]
  (and (not is-read-only-user?)
       (or is-admin?
           (= @session/view-id :entity.type/tenant-kyc-profile)
           (not (tenant-customizations/capman?)))))

(defn resolve-delete-extra-note
  [entity]
  (case (:entity/type entity)
    :entity.type/person
    (when (session/contact-lists?)
      (let [contact-lists-with-person-count
            (->> @session/contact-lists
                 (filter (fn [contact-list]
                           (let [members (->> contact-list
                                              :contact-list/members)
                                 is-member? (some #{(:db/id entity)} members)]
                             is-member?)))
                 (count))]
        (when (< 0 contact-lists-with-person-count)
          (loc/tr :delete-confirmation-person-in-contact-lists))))
    nil))

(defn delete-button
  ([entity success-view-path]
   (delete-button entity success-view-path #(routing/set-view! success-view-path)))
  ([entity _success-view-path on-success]
   (let [is-read-only-user? @(rf/subscribe [::app-core-sub/is-read-only-user?])
         is-admin? @(rf/subscribe [::app-core-sub/is-admin?])]
     (when (delete-allowed? is-read-only-user? is-admin?)
       (let [body-extra-note (resolve-delete-extra-note entity)]
         {:toolbar-button?  false
          :dropdown-action? true
          :ord              0
          :primary-button?  false
          :icon             :fa-trash
          :on-select        (fn [_e]
                              (let [entity-id (:db/id entity)
                                    error-kw (session/error-if-cannot-delete entity-id)]
                                (if error-kw
                                  (modals/open-modal!
                                   error-message-modal/modal-key
                                   {:body-content   (loc/tr error-kw)
                                    :title          (loc/tr :attention)
                                    :ok-button-text (loc/tr :back)})
                                  (modals/open-modal! delete-confirmation/modal-key
                                                      (merge
                                                       {:body       (loc/tr
                                                                     :delete-confirmation-body-text
                                                                     [(loc/tr (:entity/type entity))
                                                                      (entity/resolve-entity-name entity session/get-entity session/reverse-lookup)])
                                                        :on-delete! (fn [_]
                                                                      (entity-actions/*->disable!
                                                                       {:db/id entity-id}
                                                                       on-success
                                                                       show-error-message!))}
                                                       (when body-extra-note
                                                         {:body-extra-note body-extra-note}))))))
          :label            (loc/tr :delete)})))))

(defn back-label
  [text]
  [:div
   {:class "flex items-center gap-2 [&_.empty]:py-0"}
   [back-button nil]
   [label text]])

(defn toolbar-back
  [target-route link-label]
  [:div
   {:class "flex"}
   [button/secondary-open
    {:variant  "link"
     :on-click (fn [_e]
                 (routing/set-view! target-route))}
    [:span.d-flex.align-items-center
     [:i.fal.fa-angle-left]
     [:span link-label]]]])

(defn search-input
  [on-change placeholder on-click search]
  [:input
   {:class       "py-2 px-3 w-full
                  text-input-light-text placeholder:text-input-light-text-paler leading-5
                  outline-0 border border-solid border-input-light-border-paler hover:border-input-light-border
                  focus:ring-inset focus:ring-input-light-border focus-visible:ring-input-light-border
                  rounded-full
                  bg-base-light
                  shadow-none"
    :type        "text"
    :on-click    on-click
    :value       search
    :on-change   on-change
    :placeholder placeholder}])

(defn search-elems
  [{:keys [on-change state placeholder]}]
  (let [{:keys [input]} (:search @state)]
    [:div
     {:class "relative min-w-36"}
     [search-input on-change placeholder identity input]
     [:i.fal.fa-search
      {:class "absolute top-1/2 right-2 -translate-y-1/2"}]]))

(defn dropdown
  [dropdown-actions _force-dropdown-visible?]
  (when-not (empty? dropdown-actions)

    [dropdown-menu/view
     {:trigger [dropdown-menu/button-trigger-open
                [:i.fas.fa-ellipsis-v]]
      :items   (->> dropdown-actions
                    (map
                     (fn [action]
                       (let [{:keys [label icon show-tooltip? tooltip-text divider
                                     divider? on-select disabled? custom-item? value items
                                     sub-menu-side add-ellipsis?]} action
                             show-tooltip? (or show-tooltip?
                                               (and disabled? (not (cu/blank-value? tooltip-text))))]
                         (cond-> {:label          label
                                  :icon-class     (uu/cm "fal" icon)
                                  :item-class     (when add-ellipsis?
                                                    "after:content-['…'] after:-ml-3")
                                  :separator?     divider?
                                  :disabled?      (boolean disabled?)
                                  :custom-item?   custom-item?
                                  :value          value
                                  :section-label? (true? divider)
                                  :on-click       on-select
                                  :sub-menu-side  sub-menu-side
                                  :tooltip        (when show-tooltip?
                                                    tooltip-text)}
                           (seq items) (assoc :items items)))))
                    (doall))}]))

(defn buttons
  [button-actions]
  [:div
   {:class-name "hidden md:flex gap-2"}
   (doall
    (for [action button-actions
          :let [{:keys [label icon ord custom-render on-select tooltip-text disabled? hidden?]}
                action
                hidden? (if (fn? hidden?)
                          (hidden?)
                          hidden?)
                show-tooltip? (and disabled? (not (cu/blank-value? tooltip-text)))]]
      (when-not hidden?
        [:div
         {:key (str "toolbar-button-" ord)
          :id  (str "toolbar-button-" ord)}
         (if custom-render
           [custom-render action]
           [button/sm-secondary-solid
            {:on-click  (fn [e]
                          (when-not disabled?
                            (on-select e)))
             :disabled? disabled?
             :tooltip   (when show-tooltip?
                          tooltip-text)}
            (when icon
              [:i {:class-name (fu/cs "fal" icon "")}
               " "])
            (if (fn? label)
              (label action)
              label)])])))])

(defn dropdown-button-component
  [{:keys [label tooltip-text disabled? action open?]}]
  (let [show-tooltip? (and disabled? (not (cu/blank-value? tooltip-text)))]
    [button/primary-solid
     {:disabled? disabled?
      :tooltip   (when show-tooltip?
                   tooltip-text)}
     (if (fn? label)
       (label action)
       label)
     (if open?
       [:i.fal.fa-chevron-up]
       [:i.fal.fa-chevron-down])]))

(defn dropdown-button-view
  [_]
  (let [local-state (r/atom {})]
    (fn [{:keys [custom-style ord label action tooltip-text custom-render primary-button? disabled? hidden?] :as dropdown-button}]
      (let [dropdown-actions (->> dropdown-button
                                  :options)
            hidden? (if (fn? hidden?)
                      (hidden?)
                      hidden?)]
        (when-not hidden?
          [:div
           {:key   (str "toolbar-button-" ord)
            :id    (str "toolbar-button-" ord)
            :class "zap-toolbar__buttons__container px-1"}
           (if custom-render
             [custom-render action]
             [dropdown-button/view
              {:dropdown-actions        dropdown-actions
               :force-dropdown-visible? true
               :button                  (when-not (empty? dropdown-actions)
                                          [dropdown-button-component
                                           {:custom-style    custom-style
                                            :primary-button? primary-button?
                                            :disabled?       disabled?
                                            :tooltip-text    tooltip-text
                                            :label           label
                                            :action          action
                                            :open?           (get @local-state :open?)}])
               :class-name              "services-navbar"
               :on-toggle!              (fn [toggled?]
                                          (swap! local-state assoc :open? toggled?))}])])))))

(defn dropdown-buttons-view
  [dropdown-buttons]
  [:<>
   (doall
    (for [{:keys [ord] :as dropdown-button} dropdown-buttons]
      ^{:key (str "dropdown-button-" ord)}
      [dropdown-button-view dropdown-button]))])

(defn view
  ([state label-renderer search-renderer tool-actions]
   (view state label-renderer search-renderer tool-actions nil))
  ([state label-renderer search-renderer tool-actions custom-items-renderer]

   (let [tool-actions (if (fn? tool-actions)
                        (tool-actions state)
                        tool-actions)
         max-ord (->> tool-actions
                      (keep :ord)
                      (apply max 0))
         tool-actions (->> tool-actions
                           (map-indexed (fn [idx {:keys [ord] :as ta}]
                                          (assoc ta
                                                 :ord
                                                 (or ord
                                                     (+ idx max-ord 1))))))
         toolbar-button? (fn [a]
                           (and (not (:options a))
                                (:toolbar-button? a)))
         button-actions (->> tool-actions
                             (filter toolbar-button?)
                             (sort-by :ord)
                             (reverse))
         dropdown-button? (fn [a]
                            (and (:options a)
                                 (:toolbar-button? a)))
         dropdown-button-actions (->> tool-actions
                                      (filter dropdown-button?)
                                      (sort-by :ord)
                                      (reverse))
         dropdown-actions (->> tool-actions
                               (filter :dropdown-action?)
                               (sort-by :ord))
         force-dropdown-visible? (->> tool-actions
                                      (some (fn [a]
                                              (and (not (:toolbar-button? a))
                                                   (:dropdown-action? a)
                                                   (not (:divider a))))))]
     [:div
      {:class "min-h-14 py-2 px-3 flex justify-between gap-3
                    border border-solid border-base-light-border-paler
                    bg-base-light sticky top-0 z-10"}
      [:div
       {:id    "zap-toolbar__navigation"
        :class "flex justify-between items-center [&>.empty]:py-0"}
       (when label-renderer
         (label-renderer state))]

      [:div
       {:class "flex gap-3 items-center"}
       (when custom-items-renderer
         [custom-items-renderer])
       (when search-renderer
         [:div
          {:class "invisible sm:visible"}
          (search-renderer)])
       [dropdown-buttons-view dropdown-button-actions]
       [buttons button-actions]
       [dropdown dropdown-actions force-dropdown-visible?]]])))

;; Note: 'nev-dropdown' and 'nev-toolbar' are temporary - complete overhaul likely in a later release
;;       => mostly just copy-pasted for now:
(defn nev-dropdown
  [{:keys [dropdown-actions]}]
  (when-not (empty? dropdown-actions)
    [dropdown-menu/view
     {:trigger [dropdown-menu/button-trigger-open
                [:i.fas.fa-ellipsis-v]]
      :items   (->> dropdown-actions
                    (map
                     (fn [action]
                       (let [{:keys [label icon divider divider? on-select disabled? custom-item? value]}
                             action]
                         {:label          label
                          :icon-class     (uu/cm "fal" icon)
                          :separator?     divider?
                          :disabled?      (boolean disabled?)
                          :section-label? (true? divider)
                          :custom-item?   custom-item?
                          :value          value
                          :on-click       on-select})))
                    (doall))}]))

(defn nev-toolbar
  [{:keys [state label search-renderer actions custom-items-renderer
           dropdown-toggle dropdown-toggle-class-name]}]
  (let [actions (if (fn? actions)
                  (actions state)
                  actions)
        max-ord (->> actions
                     (keep :ord)
                     (apply max 0))
        actions (->> actions
                     (map-indexed (fn [idx {:keys [ord] :as ta}]
                                    (assoc ta
                                           :ord
                                           (or ord
                                               (+ idx max-ord 1))))))
        toolbar-button? (fn [a]
                          (and (not (:options a))
                               (:toolbar-button? a)))
        button-actions (->> actions
                            (filter toolbar-button?)
                            (sort-by :ord)
                            (reverse))
        dropdown-button? (fn [a]
                           (and (:options a)
                                (:toolbar-button? a)))
        dropdown-button-actions (->> actions
                                     (filter dropdown-button?)
                                     (sort-by :ord)
                                     (reverse))
        dropdown-actions (->> actions
                              (filter :dropdown-action?)
                              (sort-by :ord))
        force-dropdown-visible? (->> actions
                                     (some (fn [a]
                                             (and (not (:toolbar-button? a))
                                                  (:dropdown-action? a)
                                                  (not (:divider a))))))]
    [:div
     {:class "px-4 py-1 flex items-center justify-between
                   bg-base-light
                   border-b border-solid border-base-light-border-paler"}
     [:div
      {:id         "zap-toolbar__navigation"
       :class-name "w-full flex justify-between gap-6"}
      (when label
        (label state))]
     (when custom-items-renderer
       [custom-items-renderer])
     (when search-renderer
       [:div
        {:class-name "d-none d-sm-block zap-toolbar__search"}
        (search-renderer)])
     [dropdown-buttons-view dropdown-button-actions]
     [buttons button-actions]
     [nev-dropdown
      {:dropdown-actions           dropdown-actions
       :force-dropdown-visible?    force-dropdown-visible?
       :dropdown-toggle            dropdown-toggle
       :dropdown-toggle-class-name dropdown-toggle-class-name}]]))
